import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=3ec2a039"
import script from "./ImageBanner.vue?vue&type=script&lang=js"
export * from "./ImageBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports